import React from "react";
import styles from "./styles.module.scss";
import { Textarea } from "../../../../../../shared/Textarea/Textarea";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";

/**
 * @param {{
 *  description?: string;
 *  title: string;
 *  children: React.ReactNode;
 *  required?: boolean;
 *  allowComment?: boolean;
 *  comment?: string;
 *  onCommentChange?: (comment: string) => void;
 * }} param0
 */
export function Wrapper({
  description,
  title,
  children,
  required,
  allowComment,
  comment,
  onCommentChange,
}) {
  var { tSurvey: t } = useAppTranslation.Survey();

  return (
    <div className={styles.root}>
      <div>
        <h3>
          {title} {required && <span>*</span>}
        </h3>
        {description && <p>{description}</p>}
      </div>
      <div>{children}</div>
      {allowComment && (
        <Textarea
          className={styles.comment}
          value={comment}
          onChange={(e) => onCommentChange(e.target.value)}
          placeholder={t("text_paceholder")}
        />
      )}
    </div>
  );
}
